import React from 'react';
import PropTypes from "prop-types";
import { Link, NavLink } from "react-router-dom";
import {
    XMarkIcon,
    ChartBarIcon,
    CreditCardIcon,
    SparklesIcon,
    HomeIcon,
    UsersIcon,
    CogIcon,
    MapIcon,
    TableCellsIcon,
    MapPinIcon,
    RectangleGroupIcon
} from "@heroicons/react/24/outline";
import {
    Button,
    IconButton,
    Typography,
} from "@material-tailwind/react";
import { useState } from "react";

export function SideNavUx({ setOpenSidenav, openSidenav }) {
    const routes = [
        {
            path: "/ux/dashboard",
            name: "Dashboard",
            icon: <ChartBarIcon className="h-5 w-5" />,
        },
        {
            path: "/payments",
            name: "Pago",
            icon: <CreditCardIcon className="h-5 w-5" />,
        },
        {
            path: "/ux/map",
            name: "Map",
            icon: <MapIcon className="h-5 w-5" />,
        },
        {
            path: "/lots",
            name: "Predios",
            icon: <HomeIcon className="h-5 w-5" />,
        },
        {
            path: "/neighborhoods",
            name: "Colonias",
            icon: <RectangleGroupIcon className="h-5 w-5" />,
        },
        {
            path: "/sectors",
            name: "Sectores",
            icon: <HomeIcon className="h-5 w-5" />,
        },
        {
            path: "/cities",
            name: "Ciudades",
            icon: <MapPinIcon className="h-5 w-5" />,
        },
        {
            path: "/ux/reports",
            name: "Reportes",
            icon: <TableCellsIcon className="h-5 w-5" />,
        },
        {
            path: "/users",
            name: "Usuarios",
            icon: <UsersIcon className="h-5 w-5" />,
        },
        {
            path: "/roles",
            name: "Roles",
            icon: <CogIcon className="h-5 w-5" />,
        },
    ];

    const sidenavTypes = {
        dark: "bg-gradient-to-br from-gray-800 to-gray-900",
        white: "bg-white shadow-sm",
        transparent: "bg-transparent",
    };

    return (
        <aside
            className={`${sidenavTypes.white} ${openSidenav ? "translate-x-0" : "-translate-x-80"} fixed inset-0 z-50 my-4 ml-4 h-[calc(100vh-32px)] w-72 rounded-xl transition-transform duration-300 xl:translate-x-0 border border-blue-gray-100`}
        >
            <div className={`relative`}>
                <a href="/ux/dashboard" className="py-6 px-8 text-center">
                    <Typography
                        variant="h6"
                        color="blue-gray"
                    >
                        SUAC
                    </Typography>
                </a>
                <IconButton
                    variant="text"
                    color="white"
                    size="sm"
                    ripple={false}
                    className="absolute right-0 top-0 grid rounded-br-none rounded-tl-none xl:hidden"
                    onClick={() => setOpenSidenav(false)} // Close the sidenav
                >
                    <XMarkIcon strokeWidth={2.5} className="h-5 w-5 text-blue-900"/>
                </IconButton>
            </div>
            <div className="m-4">
                <ul key='1' className="mb-4 flex flex-col gap-1">
                    <li className="mx-3.5 mt-4 mb-2">
                        <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-black uppercase opacity-75"
                        >
                            Catastro
                        </Typography>
                    </li>
                    <li key='ux-basics'>

                        {routes.map(({ path, name, icon }) => {
                            const isActive = window.location.pathname === path;
                            return (
                                <a href={path} className="flex" key={path}>
                                    <Button
                                        variant={isActive ? "gradient" : "text"}
                                        color={isActive ? "blue" : "gray"}
                                        className="flex items-center gap-4 px-4 capitalize"
                                        fullWidth
                                    >
                                        {icon}
                                        <Typography color="inherit" className="font-medium capitalize">
                                            {name}
                                        </Typography>
                                    </Button>
                                </a>
                            );
                        })}
                    </li>
                </ul>
            </div>
        </aside>
    );
}

SideNavUx.defaultProps = {
    brandImg: "/img/logo-ct.png",
    brandName: "Material Tailwind React",
};

SideNavUx.propTypes = {
    brandImg: PropTypes.string,
    brandName: PropTypes.string,
    //routes: PropTypes.arrayOf(PropTypes.object).isRequired,
};

//SideNavUx.displayName = "/src/widgets/layout/sidenav.jsx";

export default SideNavUx;